/**
 * La foto de Google al tamaño en que se va a ver.
 *
 * Las 59 fotos del padrón llegan como `…=s96-c`: 96 px, el tamaño del avatar de
 * la barra. Estiradas a una tarjeta de cumpleaños se ven borrosas. Google sirve
 * la misma foto a cualquier tamaño cambiando ese sufijo, así que se pide la que
 * hace falta. Cualquier otra URL se deja tal cual.
 */
export const sizedPhoto = (url: string, px: number): string => {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (parsed.hostname !== 'lh3.googleusercontent.com') return url;
  return /=s\d+(-c)?$/.test(url) ? url.replace(/=s\d+(-c)?$/, `=s${String(px)}-c`) : url;
};
